import React from "react";
import { Link } from "react-router-dom";

/**
 * Where an account lands when its type has no home screen of its own.
 *
 * The route guards used to send such an account to another role's home, which
 * refused it and sent it back, forever. A page saying so is the end of that
 * loop: it tells the person what happened and gives them somewhere to go.
 */
const AccessDenied = () => (
  <div className="notfound-page">
    <main className="notfound-main">
      <p className="notfound-code">No access</p>
      <h1>This account can't open that screen</h1>
      <p>
        Your account doesn't have access to this part of Youro. If you think it
        should, ask whoever set the account up to check its type.
      </p>
      <div className="notfound-actions">
        <Link className="btn-filled" to="/">Go to the home page</Link>
        <Link className="notfound-secondary" to="/login">Sign in as someone else</Link>
      </div>
    </main>
  </div>
);

export default AccessDenied;
